import moment from 'moment';

function dateFormat(cell) {
    if (cell !== null) {
        return moment(cell, moment.ISO_8601).format('DD MMM YYYY');
    } else {
        return '';
    }
}

const numberFormat = (cell) => {
    if (cell !== null) {
        return new Intl.NumberFormat('en-GB').format(cell);
    }
};

const csvNumberFormat = (cell) => {
    if (cell !== null && cell !== undefined) {
        return new Intl.NumberFormat('en-GB').format(cell);
    } else return '';
};

const currencyFormat = (cell) => {
    if (cell != null) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        }).format(cell);
    }
};

const currencyFormatNoDecimal = (cell) => {
    if (cell != null) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            maximumSignificantDigits: 20,
            currency: 'USD',
        }).format(cell);
    }
};

const csvStringFormat = (cell) => (cell == null ? '' : cell);

const sizeFormat = (cell) => {
    var output = numberFormat(Math.ceil(cell / 1024));
    return output + ' Kb';
};

export {
    dateFormat,
    numberFormat,
    currencyFormat,
    sizeFormat,
    currencyFormatNoDecimal,
    csvNumberFormat,
    csvStringFormat,
};
